import React from "react";
import Sidebar from "../components/sidebar";
import Header from "../components/Header";
import MainBanners from "../components/banners/MainBanners";

const BannersScreen = () => {
  return (
    <>
      <Sidebar />
      <main className="main-wrap">
        <Header />
        <MainBanners />
      </main>
    </>
  );
};

export default BannersScreen;
